module.exports = __webpack_public_path__ + "static/media/lapizza.a09b3bd3.png";